// src/utils/scoring.ts
export const calculateScore = (responses: { [key: number]: string }): number => {
    let score = 0;
  
    // Define scoring criteria based on the darker areas in the ASRS v1.1 form
    const scoringCriteria: { [key: string]: string[] } = {
      "1": ['2', '3', '4'], // Question 1 scores if "Often" or "Very Often"
      "2": ['2', '3', '4'], // Question 2 scores if "Often" or "Very Often"
      "3": ['2', '3', '4'], // Question 3 scores if "Often" or "Very Often"
      "4": ['3', '4'], // Question 4 scores if "Sometimes", "Often", or "Very Often"
      "5": ['3', '4'], // Question 5 scores if "Often" or "Very Often"
      "6": ['3', '4'], // Question 6 scores if "Often" or "Very Often"
    };
  
    // Calculate the score based on user responses
    Object.entries(responses).forEach(([questionId, value]) => {
      if (scoringCriteria[questionId].includes(value)) {
        score += 1; // Add 1 point if the response matches the criteria
      }
    });
  
    return score;
  };
  
  export const interpretScore = (score: number): string => {
    if (score >= 4) {
      return 'You should consider consulting a healthcare professional.';
    } else {
      return 'Your score indicates a low likelihood of ADHD symptoms.';
    }
  };
  